import { createApp } from 'vue'
import StafetEditHoldFlow from './StafetEditHoldFlow'
import isObjectNotNullOrEmpty from 'foundation/js/isObjectNotNullOrEmpty'

const el = '.kb-component--stafet-edit-hold-flow'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StafetEditHoldFlowDOM) => {
            const externalData = StafetEditHoldFlowDOM.dataset.external
                ? JSON.parse(StafetEditHoldFlowDOM.dataset.external)
                : null
            const props = {
                stafetId: externalData.stafetId ?? null,
                holdList: externalData.holdnavne ?? [],
                holdData: externalData.holdData ?? {},
                userData: externalData.userData ?? {},
                loggedIn: isObjectNotNullOrEmpty(externalData.userData)
            }

            const component = createApp(StafetEditHoldFlow, props).use(Store)
            component.mount(StafetEditHoldFlowDOM)
        })
    }
}
